export default {
	"server_host":"https://my.snapquick.app/",
	"app_data":"app-datos/app-snapquick.json"
 }